import { render, staticRenderFns } from "./doc-file-svg.vue?vue&type=template&id=4ab8809a&scoped=true&"
var script = {}
import style0 from "./doc-file-svg.vue?vue&type=style&index=0&id=4ab8809a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab8809a",
  null
  
)

export default component.exports